/**
 * Phase 17 — US FTC-compliant generic disclosure rendered below the Cart Preview when at least
 * one item has an affiliate URL set. Suppressed when zero items have affiliate URLs (the cart is
 * showing bare sourceUrls — no affiliate relationship to disclose).
 *
 * <p>Per-retailer specific disclosure language (e.g. Amazon Associates' required wording: "As an
 * Amazon Associate, todone earns from qualifying purchases.") lands when an Amazon-specific
 * fetcher does, alongside its dedicated disclosure variant. International compliance (UK CMA / EU
 * DSA) is deferred — todone's user base is US-focused for v1.
 */
export const AffiliateDisclosureFooter = () => (
  <p className="text-[11px] leading-relaxed text-muted-foreground">
    Some links on this page are affiliate links — todone may earn a commission from qualifying
    purchases at no extra cost to you.
  </p>
)
